import React from 'react';
import { View, Text, ScrollView, TouchableOpacity, Linking } from 'react-native';
import { globalStyles } from '../styles/globalStyles';
import { BackgroundVideo } from '../components/BackgroundVideo';
import { useNavigation } from '@react-navigation/native';
import { StyleSheet } from 'react-native';

export function AboutUs() {
  const navigation = useNavigation();

  const handleEmailPress = () => {
    Linking.openURL('mailto:contact@venuereportcard.com');
  };

  return (
    <View style={globalStyles.container}>
      <BackgroundVideo />
      <View style={globalStyles.overlay}>
        <ScrollView style={styles.scrollContainer}>
          <TouchableOpacity
            style={styles.backButton}
            onPress={() => navigation.goBack()}
          >
            <Text style={styles.backButtonText}>← Back</Text>
          </TouchableOpacity>

          <View style={styles.contentContainer}>
            <Text style={styles.title}>ABOUT US</Text>
            
            <Text style={styles.paragraph}>
              Thank you for visiting Venue Report Card.
            </Text>

            <Text style={styles.paragraph}>
              This website gathers music venue specifications that are relevant to visiting performers and their crew. All of the info found on this site is updated manually after reviewing each venue's website, photos, and tech spec packets when available.
            </Text>

            <Text style={styles.paragraph}>
              The best way to confirm any venue's equipment and facilities is to advance directly with the venue, and we encourage you to do this. As touring artists ourselves, however, we know this isn't always easy and that's why we created the site. Also, we thought it would be fun to be able to route a tour around specs like pinball, floor stages, and available showers.
            </Text>

            <Text style={styles.paragraph}>
              A note on Tech Specs: "Backline" confirms only that a house drum kit is provided. We may add some gear lists here and there but we are keenly aware that amps often break or get swapped out. We know it can be a hassle to bring a full kit to a show so, drums are our main criteria when considering backline. If a venue has stated they provide a backline drum set then a "yes" is shown. Amps are most likely available at venues that have a house drum kit.
            </Text>

            <Text style={styles.paragraph}>
              We encourage you to confirm gear when you're booking.
            </Text>

            <Text style={styles.paragraph}>
              We never intend to share sensitive information like venue manager emails, venue wifi, door codes, etc. If you find information like this anywhere on the site, contact us at{' '}
              <Text style={styles.link} onPress={handleEmailPress}>
                contact@venuereportcard.com
              </Text>
            </Text>

            <Text style={styles.paragraph}>
              Please use all information collected on this site at your own risk. It is always best to advance directly with a venue, but we do hope that with a little community effort, together we can keep our listings updated and relevant. You can help with this by giving a thumbs up or down on each venue page. This feedback will help us review our listings. If you have new tech specs to share, please do so in the "share venue specs" page on the venue listing.
            </Text>

            <Text style={styles.paragraph}>
              As we continue to build the site, we'd love to hear from you. What kind of venue information would you like to see? Email us at{' '}
              <Text style={styles.link} onPress={handleEmailPress}>
                contact@venuereportcard.com
              </Text>
            </Text>
          </View>
        </ScrollView>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  scrollContainer: {
    width: '100%',
    maxWidth: 1200,
    alignSelf: 'center',
    padding: 20,
  },
  contentContainer: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: 10,
    padding: 30,
    marginTop: 20,
    marginBottom: 40,
  },
  backButton: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: 8,
    padding: 10,
    alignItems: 'center',
    marginBottom: 20,
    alignSelf: 'flex-start',
    minWidth: 100,
  },
  backButtonText: {
    color: '#000000',
    fontFamily: 'VastagoGrotesk',
    fontSize: 16,
  },
  title: {
    fontFamily: 'Playpen Sans',
    fontSize: 48,
    color: '#000000',
    marginBottom: 30,
    textAlign: 'center',
    textShadow: '0px 2px 4px rgba(0,0,0,0.25)',
  },
  paragraph: {
    fontFamily: 'VastagoGrotesk',
    fontSize: 16,
    color: '#000000',
    marginBottom: 20,
    lineHeight: 24,
  },
  link: {
    color: '#2ecc71',
    textDecorationLine: 'underline',
  },
}); 